import React, { lazy } from 'react'
import { Route } from 'react-router'
import { SubRouter } from '@/router/SubRouter'

const Index = lazy(() => import('./Index'))

//	///////////////////////
//	MARK: EXPORTS
// P5, P12 — le tableau de flotte : la flotte, et le client pour ses avions (sans commentaire ni archive).
export const MaintenanceFleetRouter = React.memo(() => (
  <SubRouter loggedIn roles={['role--maintenance--fleet', 'role--maintenance--client']}>
    <Route path='*' element={<Index />} />
  </SubRouter>
))
